import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { HSTSToast } from "../utils/hstsToast";
import { ToastContainer } from "react-toastify";
import { userLogin } from "../services/AuthService";
import { getStudentByEmail } from "../services/StudentService";
import { getCoordinatorByEmail } from "../services/CoordinatorService";

const HSTSLogin = () => {
  const navigator = useNavigate();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({ username: "", password: "" });

  const formValidation = () => {
    let valid = true;
    const errorrsCopy = { ...errors };
    if (!username.trim()) {
      errorrsCopy.username = "User name is required.";
      valid = false;
    }
    if (!password.trim()) {
      errorrsCopy.password = "Password is required.";
      valid = false;
    }
    setErrors(errorrsCopy);
    return valid;
  };

  const handleFocus = (field) => {
    if (!errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleBlur = (field, value) => {
    if (!value.trim()) {
      setErrors((prev) => ({
        ...prev,
        [field]: `${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required.`,
      }));
    } else {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const checkUserStatus = async (role, email) => {
    try {
      if (role === "Student") {
        const res = await getStudentByEmail(email);
        if (res.data.data.student_status === "enable") {
          navigator("/student");
        } else {
          HSTSToast(
            "error",
            "Your account is IN ACTIVE. Contact to IT Service Desk for help."
          );
        }
      } else if (role === "Coordinator") {
        const res = await getCoordinatorByEmail(email);
        if (res.data.data.coordinator_status === "enable") {
          navigator("/coordinator");
        } else {
          HSTSToast(
            "error",
            "Your account is IN ACTIVE. Contact IT Service Desk for help."
          );          
        }
      }
    } catch (err) {
      console.error("Error fetching user status:", err);
      console.warn(" display data ", email);
      
      HSTSToast("error", "Unable to verify status. Contact IT Service Desk.");
    }
  };

  const loginFormHandler = async (e) => {
    e.preventDefault();
    if (!formValidation()) return;

    try {
      const response = await userLogin({ username, password });
      
      const token = response.data.data.token;

      // console.warn(" data center ", token);

      if (!token || typeof token !== 'string') {
        HSTSToast("error", "Invalid response from server");
        return;
      }

      localStorage.setItem("token", token);

      const decodedToken = jwtDecode(token);
      const role = decodedToken.role;
      const email = decodedToken.username;

      switch (role) {
        case "Admin":
          navigator("/admin");
          break;
        case "Student":
        case "Coordinator":
          await checkUserStatus(role, email);
          break;
        default:
          HSTSToast("warn", "Please try again later");
          console.log("Unknown role:", role);
          break;
      }
    } catch (error) {
      // console.warn(" Data details ==> ");
      
      HSTSToast("error", "Wrong username or password");
      console.error("Login error:", error);
    }
  };

  return (
    <>
      <div className="wrapper vh-100">
        <div className="row align-items-center h-100">
          <form className="col-lg-3 col-md-4 col-11 mx-auto">
            <div className="card zis-shadow rounded-3">
              <div className="card-body">
                <div className="text-center">
                  <h1
                    className="h6 mb-3 text-black fw-semibold"
                    style={{ fontFamily: "initial", fontSize: "x-large" }}
                  >
                    HETRAS Login
                  </h1>
                </div>
                <div className="form-group">
                  <label className="text-black">Enter username</label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.username ? "is-invalid" : ""
                    }`}
                    onChange={(e) => setUserName(e.target.value)}
                    onFocus={() => handleFocus("username")}
                    onBlur={() => handleBlur("username", username)}
                    placeholder="Please enter username"
                  />
                  {errors.username && (
                    <div className="invalid-feedback">{errors.username}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="text-black">Enter password</label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control ${
                        errors.password ? "is-invalid" : ""
                      }`}
                      onChange={(e) => setPassword(e.target.value)}
                      onFocus={() => handleFocus("password")}
                      onBlur={() => handleBlur("password", password)}
                      placeholder="Please enter password"
                    />
                    <button
                      type="button"
                      className="input-group-text"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={`fa ${
                          showPassword ? "fa-eye-slash" : "fa-eye"
                        }`}
                      />
                    </button>
                  </div>
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                </div>

                <div className="form-group mb-3">
                  <button
                    className="btn btn-black w-100 rounded-3"
                    onClick={loginFormHandler}
                  >
                    Let me in
                  </button>
                </div>
                <div className="d-flex form-group">
                  <Link to="/resetPassword" className="ms-auto text-black">
                    Forget password.
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default HSTSLogin;
